import React, { Component } from 'react';
import Highcharts from 'react-highcharts';
import chartsConfig from '../../common/chartsConfig';

const DefaultLegend = {
    align: 'right',
    verticalAlign: 'top',
    x: 0,
    y: 20,
    layout: 'vertical',
    width: 100,
};

class Chart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            legendEnable: true,
        };
    }

    getExporting = () => {
        const { filename, onExport } = this.props;
        const menuItems = [
            'downloadJPEG',
            'downloadPDF',
            'downloadPNG',
            'downloadSVG'
        ];
        if (onExport) {
            menuItems.push({
                onclick: onExport,
                text: '导出Excel'
            })
        }
        return {
            enabled: true,
            filename,
            buttons: {
                contextButton: {
                    align: "right",
                    x: -10,
                    y: -10,
                    menuItems
                }
            },
            chartOptions: {
                legend: {
                    x: -24,
                    width: false,
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                }
            },
            allowHTML: true,
            sourceWidth: 1000,
			sourceHeight: 500,
        };
    }

    getChartsConfig() {
        const { legendEnable } = this.state;
        const { title = {
            text: null
        }, type = null, xAxis = {}, yAxis = {}, tooltip = {}, plotOptions = {}, series, legend: propLegend } = this.props;
        const legend = Object.assign({ enabled: legendEnable }, DefaultLegend, propLegend);
        return {
            chart: {
                type,
                zoomType: 'xy',
                marginTop: 30,
                height: 500,
            },
            title,
            xAxis: {
                crosshair: true,
                ...xAxis
            },
            yAxis,
            tooltip: {
                shared: true,
                ...tooltip
            },
            plotOptions,
            legend,
            series,
            exporting: this.getExporting(),
            credits: {
                enabled: false,
            },
        };
    }

    render() {
        return (
            <div className="chart">
                <Highcharts config={{ ...chartsConfig, ...this.getChartsConfig() }} />
            </div>
        );
    }
}

export default Chart;



// WEBPACK FOOTER //
// ./src/components/homePage/components/Chart.js